import React, { useEffect, useState } from 'react'
import Submenu from '../../UI/menu/submenu/Submenu'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const SubmenuSuppliers = () => {

    const [list, setList] = useState([])

    useEffect(() => {
        setMenu()
    }, [])

    const setMenu = () => {
        const listTemp = []

        listTemp.push({
            url: '/supply/orders',
            name: 'Заявки',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })
        listTemp.push({
            url: '/supply/bills',
            name: 'Рахунки',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })
        listTemp.push({
            url: '/supply/bill-items-all',
            name: 'Всі позиції',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })
        listTemp.push({
            url: '/supply/suppliers',
            name: 'Постачальники',
            ico: <FormatListBulletedIcon />,
            // isActive: false
        })

        setList(listTemp)
    }
    
  return (
    <Submenu 
        list={list}
    />
  )
}

export default SubmenuSuppliers